import React from "react";
import Calcestcomp from "../../Components/Homecomp/Calccomp/Calcestcomp";
import Topslider from "../../Components/Homecomp/Calccomp/Topslider";
import Topslider2 from "../../Components/Homecomp/Calccomp/Topslider2";
export default function Homeest() {
  return (
    <div className="Home-main">
        <Topslider2 />
        <br>
        </br><br></br><br/>
      <div className="Home-c1">
        <Calcestcomp />
      </div>
    </div>
  );
}
